import { MenuService } from './../services/menu.service';
import { ChangeDetectorRef, Component, OnInit, Renderer2 } from '@angular/core';
import * as objectPath from 'object-path';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { filter } from 'rxjs';
import { NgClass, AsyncPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    imports: [NgClass, RouterLink, AsyncPipe, TranslateModule]
})
export class SidebarComponent implements OnInit {
  currentRouteUrl = '';
  showDynamic = false;

  constructor(
    public menuService: MenuService,
    private router: Router,
    private render: Renderer2,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.currentRouteUrl = this.router.url.split(/[?#]/)[0];
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        this.currentRouteUrl = this.router.url.split(/[?#]/)[0];
        this.cdr.markForCheck();
      });

    this.menuService.hideDynamicMenu$.subscribe((val) => {
      if (val) {
        this.showDynamic = false;
      }
    });
  }

  isMenuItemIsActive(item: {
    submenu: any;
    page: string;
    disabled: boolean;
  }): boolean {
    if (item.submenu) {
      return this.isMenuRootItemIsActive(item);
    }

    if (!item.page) {
      return false;
    }

    return this.isCurrentPageActive(item.page);
  }

  isCurrentPageActive(pageUrl: string): boolean {
    return (
      this.currentRouteUrl === pageUrl ||
      this.isCustomerPageUrl(pageUrl) ||
      this.isReconciliationPage(pageUrl)
    );
  }

  isCustomerPageUrl(inPageUrl: string) {
    // in case url is like /customer/:id
    let re = /customer/gi;
    return inPageUrl.search(re) >= 0 && this.currentRouteUrl.search(re) >= 0;
  }

  isReconciliationPage(inPageUrl: string) {
    let re = /ar-reconciliation/gi;
    return inPageUrl.search(re) >= 0 && this.currentRouteUrl.search(re) >= 0;
  }
  /**
   * Check Menu Root Item is active
   * @param item: any
   */
  isMenuRootItemIsActive(item: { submenu: any }): boolean {
    let result = false;

    for (const subItem of item.submenu) {
      result = this.isMenuItemIsActive(subItem);
      if (result) {
        return true;
      }
    }

    return false;
  }

  /**
   * Returns Submenu CSS Class Name
   * @param item: any
   */
  getItemCssClasses(item: any) {
    let classes = ' uw-menu__item';

    if (objectPath.get(item, 'submenu')) {
      classes += ' uw-menu__item--submenu';
    }

    if (!item.submenu && this.isMenuItemIsActive(item)) {
      classes += ' uw-menu__item--active';
    }

    if (item.page === 'mastnac' && !this.menuService.mastnacSubMenuEnable) {
      classes += ' uw-menu__item--active';
    }

    if (
      (item.page === 'action' ||
        item.page === 'issue' ||
        item.page === 'negotiation') &&
      this.menuService.locked
    ) {
      classes += ' uw-menu__item--active';
    }

    if (item.submenu && this.isMenuItemIsActive(item)) {
      classes += ' show';
    } else if (item.submenu && !this.isMenuItemIsActive(item)) {
      classes = '';
    }

    // custom class for menu item
    const customClass = objectPath.get(item, 'custom-class');
    if (customClass) {
      classes += ' ' + customClass;
    }

    if (objectPath.get(item, 'icon-only')) {
      classes += ' uw-menu__item--icon-only';
    }

    return classes;
  }

  openModal(page: string) {
    this.menuService.onMenuClick(page);
  }

  redirect(page: string) {
   // this.router.navigate([page]);
    this.menuService.closeSideMenu();
  }

}
